import { Event } from '@/event-bus/event';

export class DrawerCloseEvent extends Event<void> {}
